import Datepickk from 'datepickk/dist/datepickk';

export default class DatePickker {
  constructor(rootNode) {
    this.setupPicker();
    this.setupPseudoInput(rootNode);

    this.redStatusCount = Number(rootNode.dataset.redCount);

    this.setupListener();
    this.setupHighlights();
  }

  setupPicker() {
    this.picker = new Datepickk();
    this.picker.minDate = new Date();
    this.picker.maxSelections = 1;
    this.picker.lang = 'de';
    this.picker.button = '&#10004; Speichern';
  }

  // hide actual input field, create a text input to display the user format
  setupPseudoInput(rootNode) {
    this.submitInput = rootNode;
    this.copyInput = rootNode.cloneNode();

    this.copyInput.removeAttribute('name');
    this.copyInput.removeAttribute('data-component');
    this.copyInput.removeAttribute('id');
    this.copyInput.setAttribute('type', 'text');
    this.copyInput.setAttribute('readonly', 'readonly');
    this.submitInput.setAttribute('type', 'hidden');
    this.submitInput.parentNode.appendChild(this.copyInput);
  }

  setupListener() {
    this.copyInput.addEventListener('focus', () => {
      this.picker.show({
        currentDate: this.picker.selectedDates.length ? this.picker.selectedDates[0] : null,
      });
    });

    this.picker.onClose = () => {
      this.copyInput.value = this.getUserDateFormat();
      this.submitInput.value = this.getFormDateFormat();
    };
  }

  setupHighlights() {
    this.visits = JSON.parse(this.submitInput.dataset.dates);

    this.picker.highlight = Object.keys(this.visits).map(dateString=> {
      return this.getHighlightItem(dateString, this.visits[dateString].length);
    });
  }

  getHighlightItem(dateString, count) {
    return {
      start: new Date(dateString),
      end: new Date(dateString),
      backgroundColor: count >= this.redStatusCount ? '#e2001a' : '#eea50d',
      color: '#ffffff',
      legend: count >= this.redStatusCount ? 'ausgebucht' : 'bereits gebucht',
    };
  }

  getFormDateFormat() {
    const date = this.picker.selectedDates.length ? this.picker.selectedDates[0] : false;

    return date ? `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}` : '';
  }

  getUserDateFormat() {
    const date = this.picker.selectedDates.length ? this.picker.selectedDates[0] : false;

    return date ? `${date.getDate()}.${date.getMonth() + 1}.${date.getFullYear()}` : '';
  }
}
